var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilterApplied(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "216.7,146.8 177.4,187.9 162,172.6 151,183.5 177.4,209.9 227.6,157.8  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,109.8c-5.6,0-11.1,0.7-16.3,2l83.8-90.2V9.2h-256v12.4L98,127.7V236l34.6-17.3 c12.5,17.1,32.6,28.2,55.3,28.2c37.8,0,68.5-30.7,68.5-68.5S225.8,109.8,188,109.8z M22.4,24.2h210.2L145.5,118h-36L22.4,24.2z  M125.2,205.6l-12.2,6.1V133h23.7c-10.7,12.1-17.2,28-17.2,45.4C119.5,188,121.5,197.3,125.2,205.6z M188,232.6 c-29.9,0-54.3-24.3-54.3-54.3c0-29.9,24.3-54.3,54.3-54.3c29.9,0,54.3,24.3,54.3,54.3C242.3,208.2,217.9,232.6,188,232.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterApplied);
export default __webpack_public_path__ + "static/media/icon-filter-applied.1fa8751f.svg";
export { ForwardRef as ReactComponent };